import useSWR from "swr";
import { SWRApiError, swrConfigOptions, useFetcher, useMutater } from "./swr";
import {
  CreateMeasurementCapability,
  RawMeasurementCapability,
} from "@/types/measurementCapability";
import { mapRawMeasurementCapabilities } from "@/mappers/measurementCapabilities";
import useSWRMutation from "swr/mutation";

export const useCreateMeasurementCapability = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateMeasurementCapability>(
    "/measurement_capabilities",
    mutater,
  );
};

export const useMeasurementCapabilities = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMeasurementCapability[], SWRApiError>(
    { url: "/measurement_capabilities" },
    fetcher,
    swrConfigOptions,
  );
  return { data: data.map(mapRawMeasurementCapabilities), ...rest };
};
